import Vue from 'vue'
import Vuex from 'vuex'
import alert from './modules/alert'
import auth from './modules/auth'
import user from './modules/user'
import category from './modules/category'
import job from './modules/job'
import payment from './modules/payment'
import account from './modules/account'
import review from './modules/review'
import transaction from './modules/transaction'
import notification from './modules/notification'
import device from './modules/device'
import support from './modules/support'
import faq from './modules/faq'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    alert,
    auth,
    user,
    category,
    job,
    payment,
    account,
    review,
    transaction,
    notification,
    device,
    support,
    faq
  },
  state: {},
  mutations: {}
})

export default store
